var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "affix" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingFlag,
              expression: "loadingFlag",
            },
          ],
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.docItem,
            "status-icon": "",
            "label-width": "180px",
          },
        },
        [
          _vm.showFileName
            ? _c("div", { staticClass: "title_name clearfix" }, [
                _c("p", [
                  _c("em", {
                    staticClass: "el-icon-view",
                    on: {
                      click: function ($event) {
                        return _vm.fileView()
                      },
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "doc_name",
                      on: {
                        click: function ($event) {
                          return _vm.fileView()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.docName))]
                  ),
                  !_vm.showDetail
                    ? _c("span", { staticClass: "deleteIcon" }, [
                        _c("em", {
                          staticClass: "el-icon-close",
                          on: {
                            click: function ($event) {
                              return _vm.delMent(_vm.docItem)
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          !_vm.docItem.hideLable
            ? _c("p", { staticClass: "doc-btn" }, [
                _c("input", {
                  ref: _vm.attachmentId,
                  staticStyle: { display: "none" },
                  attrs: {
                    accept: _vm.accpt,
                    multiple: _vm.multiple,
                    name: "attachmentId",
                    type: "file",
                  },
                  on: { change: _vm.uploadName },
                }),
                _c(
                  "label",
                  {
                    staticClass: "upload",
                    on: {
                      click: function ($event) {
                        return _vm.uploadBtn($event)
                      },
                    },
                  },
                  [
                    _c("em", { staticClass: "el-icon-upload2" }),
                    _c("span", [_vm._v("上传")]),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-left": "10px",
                      color: "rgba(0, 0, 0, 0.45)",
                      "font-weight": "normal",
                      "font-size": "14px",
                    },
                  },
                  [
                    _c("em", { staticClass: "el-icon-warning-outline" }),
                    _vm._v("允许上传文件：" + _vm._s(this.accpt) + " "),
                  ]
                ),
                _vm.downBtn && _vm.docItem.describeInfo
                  ? _c(
                      "b",
                      {
                        staticStyle: {
                          color: "rgba(0, 0, 0, 0.45)",
                          "font-weight": "normal",
                          "font-size": "14px",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-warning-outline",
                          staticStyle: { margin: "0 5px 0 8px" },
                        }),
                        _vm._v(_vm._s(_vm.docItem.describeInfo)),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.imgDialogVisible,
            width: "740px",
            height: "100%",
            top: "10vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.imgDialogVisible = $event
            },
            closed: _vm.dialogClose,
          },
        },
        [
          _c("img", {
            staticClass: "viewImg",
            attrs: { src: _vm.docItem.filePath, alt: "" },
            on: {
              contextmenu: function ($event) {
                $event.preventDefault()
              },
            },
          }),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.pdfDialogVisible,
            width: "100%",
            height: "100%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.pdfDialogVisible = $event
            },
            closed: _vm.dialogClose,
          },
        },
        [
          _c("iframe", {
            attrs: {
              src: _vm.pdfViewer + _vm.pdfFileSrc + "?range=true",
              frameborder: "0",
              height: "500",
              width: "100%",
            },
            on: {
              contextmenu: function ($event) {
                $event.preventDefault()
              },
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }